module.exports = __webpack_public_path__ + "static/media/grass_fed_beef_mobile_en.edf9d600.jpg";